const fields = (t) => {
  const translate = (key, fallback) => {
    if (typeof t !== 'function') return fallback

    const translated = t(key)

    return translated === key ? fallback : translated
  }

  return [
    {
      label: translate('deliveryRequest.fields.senderName', 'Nama Pengirim'),
      key: 'parent_company.name',
      isSortable: true,
      isRedirectable: true,
      tdAttr: {
        style: 'left:49.5px;position:sticky;min-width:250px;max-width:250px',
      },
      thAttr: {
        style: 'left:49.5px;position:sticky;min-width:250px;max-width:250px;z-index:1;',
      },
    },
    {
      label: translate('delivery.fields.status', 'Status'),
      key: 'status.name',
      tdAttr: {
        style: 'left:299.5px;min-width:190px;position:sticky;',
      },
      thAttr: {
        style: 'left:299.5px;min-width:190px;position:sticky;z-index:1;',
      },
    },
    {
      label: translate('deliveryRequest.fields.requestFleetTaskNumber', 'No. Penugasan Pengirim'),
      key: 'parent_number',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.customerName', 'Nama Pelanggan'),
      key: 'shipped_customer_names',
      formatter: value => value ? value.join(', ') : value,
      isSortable: true,
    },
    {
      label: translate('delivery.fields.fleetTaskNumber', 'No. Penugasan'),
      key: 'fleet_task.number',
      formatter: value => value ? value : '-',
      isSortable: true,
    },
    {
      label: translate('deliveryRequest.fields.totalDo', 'Total DO'),
      key: 'parent_total_do',
      isSortable: true,
    },
  ]
}

export default fields
